export default {"src":"/_next/static/media/logo.b075c228.svg","height":349,"width":900,"blurWidth":0,"blurHeight":0};